module.exports = __webpack_public_path__ + "static/media/survey-img.c3a5a83b.svg";